import { render, staticRenderFns } from "./SHint.vue?vue&type=template&id=0464a429"
import script from "./SHint.ts?vue&type=script&lang=ts&external"
export * from "./SHint.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports